import { render } from "./FooterService.vue?vue&type=template&id=07187189&scoped=true"
import script from "./FooterService.vue?vue&type=script&lang=js"
export * from "./FooterService.vue?vue&type=script&lang=js"

import "./FooterService.vue?vue&type=style&index=0&id=07187189&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07187189"]])

export default __exports__